module.exports = __webpack_public_path__ + "img/LTE:OK - WLAN:ERR.d92fa18e.jpg";